// @ts-nocheck
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Container, Typography } from '@mui/material';
// hooks
// components
import Page from '../components/Page';
// sections
import { LoginForm } from '../sections/auth/login';
import { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useLoginUserMutation } from '../store/api/authApi';
import { useAppDispatch } from '../store/hooks';
import { setUser } from '../store/state/authSlice';
import { useServiceProviderIdMutation } from '../store/api/serviceProviderApi';
import { useGetAllCountriesMutation } from '../store/api/countriesApi';
import { getMessage } from '../components/message';
import {
  useGetAllLabourDetailMutation,
  useFindLabourDetailByUserIdMutation,
} from '../store/api/labourApi';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [loginUser, response] = useLoginUserMutation();
  console.log("response",response)
  const token = localStorage.getItem('login') || null;
  const [serviceProviderId, serviceProviderIdResponse] = useServiceProviderIdMutation();
  const [getAllCountries, getAllCountriesResponse] = useGetAllCountriesMutation();
  const [findLabourDetailByUserId] = useFindLabourDetailByUserIdMutation();

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleLogin = async (values) => {
    localStorage.clear();
    await loginUser(values);
  };

  useEffect(() => {
    if (response.isSuccess) {
      if (getAllCountriesResponse.isSuccess) {
        const countries = getAllCountriesResponse.data || []; 
        dispatch(setCountryData(countries)); 
      } else if (getAllCountriesResponse.isError) {
        const errorData: any = getAllCountriesResponse.error;
        const msg: string = errorData?.data?.serviceErrors?.[0]?.msg || 'Unknown error';
        toast.error('Something went wrong: ' + msg);
      }
    
      if (response?.data?.categoryType === 'UTCUST') {
        toast.error(getMessage.ERROR_LOGIN_UTCUST);
        navigate('/login', { replace: true });
      } else if (response?.data?.categoryType === 'UTSA' || response?.data?.categoryType === 'UTSP' || response?.data?.categoryType === 'UTLB') {
        dispatch(setUser(response.data));
        serviceProviderId({
          token: response?.data?.jwtToken,
          id: response?.data?.id,
        });
      }
    }
  }, [response.isSuccess,  
    getAllCountriesResponse.isSuccess,
    getAllCountriesResponse.isError,
    getAllCountriesResponse.data,
    getAllCountriesResponse.error,
  ]);

  useEffect(() => {
    if (serviceProviderIdResponse.isSuccess) {
      if (response.data.categoryType === 'UTSP') {
        localStorage.setItem(
          'login',
          JSON.stringify({
            userType: response.data.categoryType,
            userId: response.data.id,
            serviceProviderId:
              response.data.serviceProviderId !== null
                ? response.data.serviceProviderId
                : serviceProviderIdResponse.data.id,
            token: response.data.jwtToken,
            merchantId: response.data.merchantId,
            currentStatus:
              response.data.serviceProviderId !== null ? 'Approved' : serviceProviderIdResponse.data?.currentStatus,
            permissions: response.data.permissions,
          })
        );
        navigate('/dashboard');
      } else if (response.data.categoryType === 'UTLB') {
        const userData = {
          userType: response.data.categoryType,
          userId: response.data.id,
          token: response.data.jwtToken,
          merchantId: response.data.merchantId,
          permissions: response.data.permissions,
        };
      
        //console.log('Setting user data for UTLB:', userData);
        localStorage.setItem('login', JSON.stringify(userData));
        
        //console.log('User ID',userData.userId);
        //console.log('Token',userData.token);

        //console.log("Calling findLabourDetailByUserId with:", {
        //  userId: userData.userId,
        //  token: userData.token,
        //});
        const handleFetchLabourDetails = async () => {
          try {
            console.log("Attempting to fetch Labour Details with:", {
              userId: userData.userId,
              token: userData.token,
            });
        
            const result = await findLabourDetailByUserId({
              userId: userData.userId,
              token: userData.token,
            }).unwrap();

            console.log("Labour detail fetched successfully:", result);
        
            localStorage.setItem("labourDetail", JSON.stringify(result));
        
            navigate("/dashboard/bookings");
        
          } catch (error) {
            console.error("Failed to fetch labour details:", error);
        
            if (error?.data) {
              console.error("API Error Response:", error.data);
            }
            if (error?.status) {
              console.error("HTTP Status Code:", error.status);
            }
        
            alert("Failed to fetch labour details. Please try again.");
          }
        };
        
        handleFetchLabourDetails();
      } else {
        localStorage.setItem(
          'login',
          JSON.stringify({
            userType: response.data.categoryType,
            userId: response.data.id,
            token: response.data.jwtToken,
            merchantId: response.data.merchantId,
            permissions: response.data.permissions,
          })
        );
        navigate('/dashboard');
      }
    }
  }, [serviceProviderIdResponse.isSuccess]);

  
  useEffect(() => {
    if (response.isError) {
      toast.error(getMessage.ERROR_LOGIN);
      navigate('/login', { replace: true });
    }
  }, [response.isError]);

  useEffect(() => {
    if (token) {
      navigate('/dashboard/app', { replace: true });
    }
  }, [token]);

  return (
    <Page title="Login">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              Sign in
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 2 }}>Enter your details below.</Typography>

            <LoginForm
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              handleShowPassword={handleShowPassword}
              handleLogin={handleLogin}
              isLoading={response.isLoading}
            />

            <div className="" style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p>Forgot your password?</p>
              <span
                className=""
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/login/forget-password');
                }}
              >
                Click here
              </span>
            </div>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
